import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const backCheques_endpoints = APIS_ENDPOINTS.backCheques

export const request_getallbackchequesbyuserprofileid = async ({userId}: {userId: number}) => {
  return http.get(backCheques_endpoints.getallbackchequesbyuserprofileid + '?UserProfileId=' + userId)
}

export const request_getallboardofdirectorsbyuserprofileid = async ({userId}: {userId: number}) => {
  return http.get(backCheques_endpoints.getallboardofdirectorsbyuserprofileid + '?UserProfileId=' + userId)
}
